import React from 'react';
import { Wordmark } from '@stockx/icons';
import { Text, Box } from '@stockx/ui';
import { BsContext } from '@app/transaction';
import { ButtonLink, Link } from '@app/router';
import NavInner from './CheckoutHeaderContent.styles';
import useCheckoutHeaderContent from './hooks/useCheckoutHeaderContent';

const CheckoutHeaderContent = () => {
  const { urlPrefix, onLogoClick, onFaqClick, buyHelp, sellHelp, t, context } =
    useCheckoutHeaderContent();

  return (
    <NavInner>
      <Link className="navbar-brand logo" to={urlPrefix}>
        <Box ml={10} onClick={onLogoClick} data-testid="bs-stockx-logo-link">
          <Wordmark width="125px" title={t('stockx_logo')} />
        </Box>
      </Link>
      <ButtonLink
        variant="link"
        mr="30"
        data-testid="bs-faq-link"
        onClick={onFaqClick}
        to={
          context === BsContext.Buy
            ? {
                pathname: buyHelp,
              }
            : {
                pathname: sellHelp,
              }
        }
        target="_blank"
      >
        <Text fontSize="md"> {t('FAQ')} </Text>
      </ButtonLink>
    </NavInner>
  );
};

export default CheckoutHeaderContent;
